/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Used_Token_AccountInputs */



/**
* | output |
* | --- |
* | "Your account has already been activated. You can log in or reset your password." |
*
* @param {Used_Token_AccountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const used_token_account = /** @type {((inputs?: Used_Token_AccountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Used_Token_AccountInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your account has already been activated. You can log in or reset your password.")
	return /** @type {LocalizedString} */ ("Votre compte a déjà été activé. Vous pouvez vous connecter ou réinitialiser votre mot de passe.")
});